import { useDefaultComputerSearchModel } from '#pplx/frontend/apps/ask/computer/ask-input/useDefaultComputerSearchModel.js';
import { usePreferredSearchModels } from '#pplx/frontend/apps/ask/settings/hooks/usePreferredSearchModels.js';
import { SearchMode, SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
export function useComputerSearchModelPreference() {
    const { getPreferredSearchModel } = usePreferredSearchModels();
    const defaultComputerSearchModel = useDefaultComputerSearchModel();
    const storedComputerSearchModel = getPreferredSearchModel(SearchMode.ASI);
    return {
        defaultComputerSearchModel,
        computerSearchModel: storedComputerSearchModel ?? defaultComputerSearchModel,
    };
}
//# sourceMappingURL=useComputerSearchModelPreference.js.map